import { Link } from 'react-router-dom';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LinkStyled = styled(Link)(({ theme }) => ({
	display: 'flex',
	margin: '0 16px',
	padding: '0 12px',
	justifyContent: 'space-between',
	alignItems: 'center',
	gap: 4,
	height: '48px',
	color: theme.palette.primary.main,
	textDecoration: 'none',
	borderRadius: 40,
	backgroundColor: theme.palette.neutral.main,
	boxShadow:
		'0 12px 22px -6px rgba(24, 39, 75, 0.12), 0 21px 64px -4px rgba(24, 39, 75, 0.12)',
})) as unknown as typeof Link;

export const SearchBarContent = styled(Stack)(() => ({
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'row',
}));
